import { useEffect } from 'react';

// Mutes the bright photo backdrop while a tasks-page is mounted so the
// cards carry the contrast. Restored on unmount.
export default function useDarkOffersBackground() {
  useEffect(() => {
    document.body.classList.remove('with-background-image');
    document.body.classList.add('with-dark-offers-background');
    return () => {
      document.body.classList.remove('with-dark-offers-background');
      document.body.classList.add('with-background-image');
    };
  }, []);
}
